import NetworkApi from "../../data/network/NetworkApi";
import NetworkApiImpl from "../../data/network/NetworkApiImpl";
import { AuthRepository } from "../../data/repository/auth/AuthRepository";
import { AuthRepositoryImpl } from "../../data/repository/auth/AuthRepositoryImpl";
import { TruckRepository } from "../../data/repository/truck/TruckRepository";
import { TruckRepositoryImpl } from "../../data/repository/truck/TruckRepositoryImpl";
import { ChangePasswordUseCase, ChangePasswordUseCaseImpl } from "../../domain/usecase/auth/ChangePassword/ChangePasswordUseCase";
import {
  LoginUseCase,
  LoginUseCaseImpl,
} from "../../domain/usecase/auth/Login/LoginUseCase";
import { GenerateXmlFileUseCase, GenerateXmlFileUseCaseImpl } from "../../domain/usecase/truck/generateXmlFile/UseCase";
import {
  GetAllTrucksUseCase,
  GetAllTrucksUseCaseImpl,
} from "../../domain/usecase/truck/getAll/UseCase";
import { provideApiBuilder } from "./NetworkModule";

function provideNetworkApi(): NetworkApi {
  return new NetworkApiImpl(provideApiBuilder());
}

// auth
function provideAuthRepository(): AuthRepository {
  return new AuthRepositoryImpl(provideNetworkApi());
}
export function provideLoginUseCase(): LoginUseCase {
  return new LoginUseCaseImpl(provideAuthRepository());
}
export function provideChangePasswordUseCase(): ChangePasswordUseCase {
  return new ChangePasswordUseCaseImpl(provideAuthRepository());
}

// trucks
function provideTruckRepository(): TruckRepository {
  return new TruckRepositoryImpl(provideNetworkApi());
}
export function provideGetAllTrucksUseCase(): GetAllTrucksUseCase {
  return new GetAllTrucksUseCaseImpl(provideTruckRepository());
}
export function provideGenerateXmlFileUseCase(): GenerateXmlFileUseCase {
  return new GenerateXmlFileUseCaseImpl(provideTruckRepository());
}
